<!-- ----------------------------------------------- -->
<template>
  <transition name="fade">
    <div v-show="showToast" :class="toastStyle">
      <v-card
        :class="toastContentStyle"
        class="grey--text text--darken-2"
        @click="viewSetting"
      >
        <div :class="msgStyle">{{ toastMessage }}</div>
      </v-card>
    </div>
  </transition>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 地図画面 選択中観測所グループ表示ポップアップ
 * TmGroupToast.vue
 * @author LIS
 */
import mixin from "../../lib/mixin.js";

export default {
  name: "map-tm-group-toast",
  mixins: [mixin],
  data() {
    return {
      /** 文字列リソース */
      text: {
        viewGroupList: [
          "水位・ダム・河川カメラ",
          "雨量",
          "水質・海岸・積雪深",
          "観測所非表示",
          "登録観測所",
          "個別設定",
        ],
        toSetting: "　　設定へ",
      },
      /** トースト表示タイマーID */
      timerId: null,
    };
  },
  computed: {
    /** 地図設定情報 */
    mapConfig: {
      get() {
        return this.$store.state.map.mapConfig;
      },
    },
    /** トーストの表示/非表示 */
    showToast: {
      get() {
        return this.$store.state.map.showTmGroupToast;
      },
    },
    /** トースト表示メッセージ */
    toastMessage: {
      get() {
        return (
          this.text.viewGroupList[this.$store.state.map.viewGroup] +
          this.text.toSetting
        );
      },
    },
    /** モード */
    isPcMode: {
      get() {
        return this.$store.state.app.mode == "pc";
      },
    },
    /** モードによってトーストのスタイルを切り替える */
    toastStyle() {
      if (this.isPcMode) {
        return "pc-toast";
      } else {
        return "mb-toast";
      }
    },
    /** モードによってトーストコンテンツのスタイルを切り替える */
    toastContentStyle() {
      if (this.isPcMode) {
        return "pc-toast-content";
      } else {
        return "mb-toast-content";
      }
    },
    /** モードによってトーストメッセージのスタイルを切り替える */
    msgStyle() {
      if (this.isPcMode) {
        return "pc-toast-message";
      } else {
        return "mb-toast-message";
      }
    },
  },
  methods: {
    /** 表示切替ダイアログ表示 */
    viewSetting() {
      // トーストを非表示
      this.$store.commit("map/setShowTmGroupToast", false);
      if (
        this.$store.state.app.mode == "mb" &&
        !this.$store.state.map.showViewGroup
      ) {
        // 地図上のダイアログを全て非表示
        this.$store.commit("map/dialogAllClose");
        // モバイルモード初期表示(全てのダイアログを非表示)
        this.routerPush("/mb");
        this.$store.commit("app/setContent", "");
      }
      this.$store.commit(
        "map/setShowViewGroup",
        !this.$store.state.map.showViewGroup
      );
    },
    /** トースト非表示のタイマー設定 */
    setFadeTimer() {
      // トースト表示タイマーIDをリセットする
      clearTimeout(this.timerId);

      if (this.showToast) {
        // 一定時間後にトーストを非表示にする
        this.timerId = setTimeout(
          this.$store.commit,
          this.mapConfig.tmGrouptoastFadeTime,
          "map/setShowTmGroupToast",
          false
        );
      }
    },
  },
  watch: {
    /** トースト表示時の処理 */
    showToast() {
      this.setFadeTimer();
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
@import "./../../scss/_media_query.scss";
.pc-toast {
  z-index: 3050;
  top: 40%;
  left: 8px;
  right: 8px;
  position: absolute;
  display: flex;
  align-items: center;

  .pc-toast-content {
    min-width: 200px;
    max-width: 500px;
    opacity: 0.9;
    margin: auto;
    .pc-toast-message {
      height: 52px;
      padding: 8px;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
@include landscape {
  .mb-toast {
    z-index: 3050;
    margin-top: 70px;
    top: 70px;
    left: 60px;
    position: absolute;
    display: flex;
    align-items: center;
    .mb-toast-content {
      min-width: 200px;
      max-width: 260px;
      opacity: 0.9;
      margin: auto;
      .mb-toast-message {
        height: 52px;
        padding: 8px;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
@include portrait {
  .mb-toast {
    top: 50px;
    left: 8px;
    right: 8px;
    z-index: 3050;
    margin-top: 100px;
    position: absolute;
    display: flex;
    align-items: center;
    .mb-toast-content {
      min-width: 200px;
      max-width: 500px;
      opacity: 0.9;
      margin: auto;
      .mb-toast-message {
        height: 52px;
        padding: 8px;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
